// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EBLi","name":"styles_name__J7HZp","phone":"styles_phone__HJO9U"};